<template>
  <div>
  <div class="container-fluid white-bg centers-list fr-page">
    <div class="container align-middle pdrght0px">
      <div class="row">
        <div class="col-12">
          <h1 class="zagolovok">Выберите направление для ребенка</h1>
        </div>
      </div>
      <div class="row napravleniya">
        <div class="col-12 col-sm-1"></div>
        <div class="col-12 col-sm-3">
          <a href="/home-teacher/godovoj-kurs-anglijskogo-yazyka" style="text-decoration: none;">
            <img src="@/assets/hometeacher/images/napravlen-11.png" class="desktop">
            <img src="@/assets/hometeacher/images/napravlen-mobile-11.jpg" class="mobile-index">
            <div class="napravlen">Английский язык</div></a>
        </div>
        <div class="col-12 col-sm-4" style="text-align: center;">
          <div style="max-width: 285px; margin: 0 auto;">
            <a href="/home-teacher/godovoj-kurs-anglijskij-s-rozhdeniya" style="text-decoration: none;">
              <img src="@/assets/hometeacher/images/napravlen-21.png" class="desktop">
              <img src="@/assets/hometeacher/images/napravlen-mobile-21.jpg" class="mobile-index">
              <div class="napravlen">Англомамы</div></a>
          </div>
        </div>
        <div class="col-12 col-sm-3">
          <a href="/home-teacher/godovoj-kurs-ispanskogo-yazyka" style="text-decoration: none;">
            <img src="@/assets/hometeacher/images/napravlen-3.png" class="desktop">
            <img src="@/assets/hometeacher/images/napravlen-mobile-3.png" class="mobile-index">
            <div class="napravlen">Испанский язык</div></a>
        </div>
        <div class="col-12 col-sm-1"></div>

      </div>


      <div class="row napravleniya mgtop-60">
        <div class="col-12 col-sm-3"></div>
        <div class="col-12 col-sm-3">
          <a href="/home-teacher/godovoj-kurs-skorochteniya" style="text-decoration: none;">
            <img src="@/assets/hometeacher/images/napravlen-4.png" class="desktop">
            <img src="@/assets/hometeacher/images/napravlen-mobile-4.png" class="mobile-index" style="margin-top: 15px;">
            <div class="napravlen mob-mgbt">Скорочтение</div></a>
        </div>
        <div class="col-12 col-sm-3">
          <a href="https://poliglotiki.com/home-teacher/polugodovoj-kurs-mnemotexnika" style="text-decoration: none;">
            <img src="@/assets/hometeacher/images/mnemo.jpg" class="desktop">
            <img src="@/assets/hometeacher/images/napravlen-mnemo-mob.jpg" class="mobile-index" style="margin-top: -15px;">
            <div class="napravlen">Мнемотехника</div></a>
        </div>
        <div class="col-12 col-sm-3"></div>
        <!--<div class="col-12 col-sm-3 desktop">
            <img src="/images/franch-noaktiv.jpg" class="desktop">
            <img src="/images/napravlen-mobile-6.png" class="mobile-index">
            <div class="no-aktiv">Французский язык</div>
        </div>
        <div class="col-12 col-sm-3 desktop">

            <img src="/images/podgotov-noaktiv.jpg" class="desktop">
            <img src="/images/napravlen-mobile-7.png" class="mobile-index">
            <div class="no-aktiv">Подготовка к школе на русском языке</div>
        </div>
        <div class="col-12 col-sm-3 desktop">

            <img src="/images/deutch-noaktiv.jpg" class="desktop">
            <img src="/images/napravlen-mobile-8.png" class="mobile-index">
            <div class="no-aktiv">Немецкий язык</div>
        </div>-->
      </div>
    </div>
  </div>
  <div class="container-fluid green-grad">
    <div class="container align-middle">
      <div class="row white-kapla-left nagreen"></div>
      <div class="row">
        <div class="col-12 col-sm-7">
          <h2>С “Полиглотиками”<br>
            учить иностранный язык &ndash;<br>
            <span class="vesinteres">весело и интересно!</span></h2>
        </div>
        <div class="col-12 col-sm-5" style="text-align: center;">
          <img src="@/assets/hometeacher/images/left-strelka.png">
          <div class="knpk-yellow">
            <a href="/home-teacher/try-free">Попробовать бесплатно</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid green-grad-wave desktop"></div>

    <div class="container-fluid white-bg centers-list fr-page no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12 col-sm-3 home-top-grey mob-70">
            <div class="block-grey">
              <p>более</p>
              <span class="big-grey">70</span>
              <span class="small-green">курсов</span>
              <p>уникальных авторских<br> программ обучения</p>
            </div>
            <div class="land-t-delimeter mobile-vers" style="margin-top: 40px;"></div>
          </div>
          <div class="col-sm-3 home-top-grey">
            <div class="block-grey">
              <p>c</p>
              <span class="big-grey">2006</span>
              <span class="small-green">года</span>
              <p>преподаем иностранные<br> языки детям</p>
            </div>
            <div class="land-t-delimeter mobile-vers" style="margin-top: 40px;"></div>
          </div>
          <div class="col-sm-3 home-top-grey">
            <div class="block-grey">
              <p>более</p>
              <span class="big-grey">200</span>
              <span class="small-green">тыс</span>
              <p>довольных учеников</p>
            </div>
            <div class="land-t-delimeter mobile-vers" style="margin-top: 40px;"></div>
          </div>

          <div class="col-sm-3 home-top-grey">
            <div class="block-grey">
              <p>от</p>
              <span class="big-grey">90</span>
              <span class="small-green">{{ $t('cur') }}</span>
              <p>стоимость одного урока</p>
            </div>

          </div>
          <div class="col-sm-2"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter desktop" style="margin-top: 40px;"></div>
            <div class="land-t-delimeter mobile-vers" style="margin-top: 80px; height: 2px;"></div>

          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h2 class="zagolovok-h2">Инновационный <span class="combo">Combo-формат</span></h2>
          </div>
        </div>
        <div class="row combo-format">
          <div class="col-sm-4">
            <div class="combo-blok" style="background: #00b4f1;">
              <p>Курс видеоуроков в записи с играми, тренажёрами,<br> pdf-материалами</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="combo-blok" style="background: #70529e; padding-top: 30px;">
              <p>Групповые безлимитные онлайн-уроки с педагогом</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="combo-blok" style="background: #f18100; padding-top: 30px;">
              <p>Контроль результатов педагогом-куратором</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="prepod">Совершенно бесплатно &ndash; диагностика и составление плана развития ребёнка перед началом обучения!</p>
            <p class="podderzka">Поддержка в чате с педагогами 24 на 7!</p>

            <div style="margin: 30px auto; text-align: center;">
              <span class="knopka-exam"><a href="/home-teacher/try-free">Выбрать направление</a></span>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid grey-bg centers-list fr-page no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <h2 class="zagolovok-h2">Как проходят <span class="zanyatiya">занятия</span></h2>
            <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                    src="https://www.poliglotiki.ru/embed/WRPZaZbl6ss" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>

          </div>
        </div>
        <div class="row">
          <div class="col-12" style="text-align: center;">
            <h2 class="poprob" style="text-align: center;" id="try"><span class="poprobuj">Попробуйте бесплатно</span><br> и оставайтесь с нами!</h2>

            <form method="post" action="/home-teacher/try-free">
              <!-- <input type="text" placeholder="Ваше имя" class="ind-name">
              <input type="text" placeholder="Телефон"class="ind-phone"> -->
              <a href="/home-teacher/try-free" class="ind-zapis">{{ $t('sign_up') }}</a>

            </form>

          </div>

        </div>
      </div>
    </div>
    <div class="container-fluid grey-krivaya"></div>

    <div class="container-fluid white-bg centers-list fr-page no-shadow">
      <div class="container align-middle" style="text-align: center;">
        <div class="row">
          <div class="col-12">
            <h2 style="font-weight: bold;">Остались вопросы? Мы готовы на них ответить!</h2>
            <p>Техническая поддержка платформы работает с понедельника по пятницу, с 9:00 до 19:00 по Московскому времени.</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <a href="https://poliglotiki.com/home-teacher/entry" class="otpravit">Написать сообщение</a>
          </div>
        </div>
        <div class="land-t-delimeter" style="margin-top: 40px;"></div>
        <div class="row">
          <div class="col-12">
            <h2 class="zagolovok-h2">Отзывы</h2>
          </div>
        </div>
        <div class="row txtleft">
          <div class="col-12">
            <carousel :responsive="{0:{items:1},1000:{items:2}}">

              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt=""
                     src="@/assets/hometeacher/images/nataliya-yuferova.jpg">
                <span class="nameotzyv">Наталия Юферова</span>
                <div class="text-otziv">Добрый день. Хочу поделиться опытом занятий с Полиглотиками. Присоединились мы осенью 2020 года.
                  Дочке было 5 лет, ранее знакомства с английским языком не было...
                </div>
              </div>

              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/nadya-brandaus.jpg">
                <span class="nameotzyv">Nadya Brandaus</span>
                <div class="text-otziv">Моя дочь семилетка занимается с «Полиглотиками» уже полгода. И каждый раз ждёт новое занятие как праздника.
                  Для меня удивительно, почти час  ребёнок погружен в процесс, слушает и отвечае...
                </div>
              </div>

              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt=""
                     src="@/assets/hometeacher/images/no-avatar-1.png">
                <span class="nameotzyv">Olia Foro</span>
                <div class="text-otziv">В поисках подходящей онлайн школы английского языка для мы перепробовали огромное количество различных школ,
                  но у ребенка пропадал интерес после нескольких уроков. Попав в эту школу...
                </div>
              </div>

              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/vera-kondrateva.jpg">
                <span class="nameotzyv">Вера Кондратьева</span>
                <div class="text-otziv">Дорогие мамочки обучающие своих детей иностранным языкам с молодых ногтей,
                  ЭТО ТОЧНО ДЛЯ ВАС. Мы нашли замечательную платформу poliglotiki.com для изучения англ языка...
                </div>
              </div>
              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt=""
                     src="@/assets/hometeacher/images/elena-serebryakova.jpg">
                <span class="nameotzyv">Елена Серебрякова</span>
                <div class="text-otziv">Ребенок занимается несколько раз в неделю. Преподаватели все интересные, даже есть носители языка со знанием русского.
                  Дети всегда могут обратиться и на русском, и на английском языках...
                </div>
              </div>
              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/marina-fedorina.jpg">
                <span class="nameotzyv">Марина Федорина</span>
                <div class="text-otziv">Всем доброго дня! Хочу рассказать об онлайн курсах английского языка от #полиглотиков.
                  Старший сын учится в третьем классе, второй год изучает английский. Пошёл Миша в сентябре...
                </div>
              </div>
              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt=""
                     src="@/assets/hometeacher/images/liliya.jpg">
                <span class="nameotzyv">Юлия</span>
                <div class="text-otziv">Большое спасибо за курс <a href="https://poliglotiki.com/home-teacher/course/2/details">On Vacation</a>, дочке очень нравятся ваши занятия!
                  Всегда подпевает песни и повторяет слова, нравится что много игровых моментов...
                </div>
              </div>
              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/arina.jpg">
                <span class="nameotzyv">Арина</span>
                <div class="text-otziv">Скорочтение вживую! Полиглотики @poliglotiki порадовали! На осенних каникулах купили детям видеокурс <a href="https://poliglotiki.com/home-teacher/course/46/details">Скорочтение на poliglotiki.com</a>.
                  Цель: повышение успеваемости...
                </div>
              </div>
              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt=""
                     src="@/assets/hometeacher/images/olga-vk.jpg">
                <span class="nameotzyv">Ольга</span>
                <div class="text-otziv">Не могу не оставить свой отзыв, так как много положительных впечатлений у всей семьи! Короткие задания на "подумать",
                  на внимание, логику, и развитие техники <a href="https://poliglotiki.com/home-teacher/course/24/details">скорочтения</a>...
                </div>
              </div>
            </carousel>
          </div>
        </div>

        <div class="row" style="margin-top: 50px;">
          <div class="col-12" style="text-align: center;">
            <a href="/all-comments.html" class="allotzv">Читать все отзывы</a>
          </div>
        </div>

        <div class="row zadat">
          <div class="col-12 col-sm-6 whatp">
            <a target="_blank" title="WhatsApp" rel="nofollow" href="https://wa.me/78127751401">Задать вопрос <img src="@/assets/hometeacher/images/whatsapp.png"></a>
          </div>
          <div class="col-12 col-sm-6 tlg">
            <a target="_blank" title="Feedback" rel="nofollow" href="https://poliglotiki.com/home-teacher/entry">Задать вопрос <img src="@/assets/hometeacher/images/telegram.png"></a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import moment from 'moment';
import StudyProductSubscriptionList from "./Study/landing/StudyProductSubscriptionList";
import studyProductApi from "../data/StudyProductApi";
import Entry from "./Entry";

export default {
  components: {
    StudyProductSubscriptionList,
    carousel,
    Entry,
  },
  name: "index",

  data: function () {
    return {
      title: null,
      slug: 'index',
      subscriptions: [],
      freeSubscription: null,
      promoSuscription: null,
      courses: [],
    }
  },

  mounted() {
    moment.locale(this.$i18n.locale)
    this.loading = true

    studyProductApi.fetchStudyProductSlug(this.slug)
        .then(response => {
          this.subscriptions = response.subscriptions.filter(s => {
            if (s.price <= 0) {
              this.freeSubscription = s
              return false
            }
            return s.price > 0
          })
          this.courses = response.courses

        })
        .catch(error => {
          let data = error.response.data
          this.error = this.pretty(data)
          this.loading = false
        })

  },

  methods: {
    orderSubscription(subscription) {
      this.$router.push('/subscription/order/' + subscription.idsubscription)
    },
    aboutCourse(course) {
      this.$router.push('/course/' + course.slug + '/details')
    },
    tryFree() {
      if (this.freeSubscription) {
        this.$router.push('/subscription/order/' + this.freeSubscription.idsubscription)
      }
    }
  },

  metaInfo() {
    return {
      title: 'Иностранные языки для детей онлайн',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Курсы английского для детей от 12 месяцев до 12 лет.'
        }
      ]
    }
  },
}
</script>

<style scoped>
.napravleniya img {
  max-width: 100%;
  border-radius: 5px;
}
.mobile-index{display: none;}
.zagolovok {
  text-align: center;
  font-family: Manrope Black;
  font-size: 36px !important;
}
.mgtop-60 {margin-top: 60px;}
.green-grad {
  background-image: url(~@/assets/hometeacher/images/green-grad.png);
  overflow: hidden;
  min-height: 370px;
}
.white-kapla-left {
  background-image: url(~@/assets/hometeacher/images/green-kapla-bg.png);
  width: 196px;
  height: 64px;
  position: relative;
  top: -6px;
  left: -76px;
}
.zagolovok-h2 {
  font-size: 35px !important;
  font-family: "Manrope Black";
  color: #231c37;
  text-align: center;
}
.combo {
  background-image: url(~@/assets/hometeacher/images/combo.png);
  padding-left: 10px;
  padding-top: 2px;
  padding-bottom: 9px;
  padding-right: 8px;
}
.combo-format p {
  font-size: 24px;
  text-align: center;
}
.combo-blok {
  padding: 10px;
  max-width: 100%;
  min-height: 147px;
  border-radius: 20px;
  color: #fff;
  font-family: 'Manrope Bold';
  margin-bottom: 20px;
}
.prepod {
  font-size: 24px;
  font-family: "Manrope Light";
  color: #4f4d5c;
  margin-top: 40px;
  font-weight: bold;
}
.podderzka {
  font-size: 24px;
  color: #000;
  font-family: "Manrope Bold";
}
.vidos {
  width: 100%;
  height: 623px;
  border-radius: 10px;
}
.ind-zapis {
  /*background: #01ba3a;*/
  background: linear-gradient(to top, #01ba3a, #8bc34a);
  color: #fff;
  font-family: "Manrope Bold Alt" !important;
  font-size: 24px;
  border-radius: 30px;
  width: 230px;
  padding: 10px 40px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
}
.ind-zapis:hover {background: #01ba3a;}
.knopka-exam {
  margin-left: 10px;
  margin-right: 10px;
}
.knopka-exam a {
  display: inline-block;
  width: 255px;
  color: white;
  text-decoration: none;
  font-family: Manrope Bold;
  font-size: 18px;
  background-image: url(~@/assets/hometeacher/images/green-btn-bg.png);
  background-repeat: repeat-x;
  height: 53px;
  border-radius: 10px;
  text-decoration: none;
  box-shadow: 0px 1px 5px 0 rgb(40 40 40 / 50%);
  line-height: 51px;
  text-shadow: 1px 1px 1px rgb(53 158 33);
}
.otpravit, a.otpravit {
  background: #5ab947;
  color: #fff;
  font-family: Manrope Light !important;
}
a.otpravit {
  display: inline-block;
  line-height: 53px;
  width: 255px;
  border-radius: 7px;
  font-family: Manrope Bold !important;
  border: none;
  cursor: pointer;
  box-shadow: 0px 1px 5px 0 rgb(40 40 40 / 50%);
  margin-bottom: 30px !important;
}
.text-otziv {
  font-size: 17px;
  color: #000;
  line-height: 1.4;
  margin-top: 10px;
}
.nameotzyv {
  font-size: 21px;
  font-family: Manrope Bold;
  display: block;
  color: #000;
}
.indotz {
  float: left;
  margin-right: 20px;
  text-align: left;
}
.txtleft{text-align: left;}
@media screen and (max-width: 1199px) and (min-width: 1024px) {
  .combo-blok {min-height: 196px;}
}
@media (max-width: 1024px){
  .vidos {height: 525px;}
}
@media (max-width: 991px)
  .centers-text {
    max-width: 100%;
    text-align: center !important;
  }
  .txtleft{text-align: center;}
@media (max-width: 960px){
  .vidos {height: 388px;}
}
@media (max-width: 481px){
  .vidos {height: 268px;}
}
@media (max-width: 414px){
  .vidos {height: 231px;}
}
@media (max-width: 320px){
  .vidos {height: 209px;}
}
@media (max-width: 575px) {
  .desktop { display: none !important;}
  .mobile-index {display: inline-block !important;}
  .zagolovok {
    font-size: 24px !important;
    margin-top: 15px !important;
  }
  .napravlen {
    width: 255px;
    display: inline-block;
    top: -17px;
    margin-bottom: 20px;
  }
  .napravleniya {
    margin: 0px;
    text-align: center;
    margin-right: -30px;
    margin-left: -15px;
    margin-top: -20px;
    padding-right: 0px;
  }
  .nagreen {left: 32% !important;}
  .green-grad h2 {
    font-size: 24px;
    text-align: center;
  }
  .vesinteres {
    background-image: url(~@/assets/hometeacher/images/vesinteres-mobile.png);
    padding-left: 4px  ;
    padding-top: 0px  ;
    line-height: 2;
    padding-bottom: 5px;
    padding-right: 4px  ;
  }
  .knpk-yellow {
    margin-top: 10px;
    display: inline-block;
    width: 300px;
    border-radius: 50px;
    margin-bottom: 70px;
  }
  .home-top-grey {margin-bottom: 0px;}
  .mob-70 {margin-top: 50px;}
  .block-grey {margin-top: 0px;}
  .indotz {float: none;}
  .whatp, .tlg {
    text-align: center !important;
  }
}
</style>
